import styled from 'styled-components'

export const OuterWrapper = styled.div`
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.palette.light};
  justify-content: center;
  width: 100%;
  height: 100vh;
`

export const LoginWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: ${(props) => props.theme.mp.sm};
  border: 0.5px solid;
  border-color: ${(props) => props.theme.palette.light};
  box-shadow: 0px 2pt 3pt #00000029;
  background-color: white;
  width: 410px;
  @media only screen and (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    width: 100%;
    border-radius: 0;
    border: none;
    box-shadow: none;
  }
`

export const LoginHeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 1rem;
  background-color: #03a9f41a;
`

export const WelcomeBackWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: ${(props) => props.theme.palette.primary};
  > h3 {
    font-weight: ${(props) => props.theme.font.weights.semiBold};
  }
`

export const LoginHeaderWelcomeBackImage = styled.img`
  max-width: 100%;
  height: auto;
`

export const UpshiftLogoWrapper = styled.div`
  width: 15%;
`

export const UpshiftLogo = styled.img`
  position: relative;
  top: -1.5rem;
  left: 1rem;
  max-width: 100%;
  height: auto;
`

export const LoginContentWrapper = styled.div`
  padding: 0 10%;
  text-align: center;
  display: flex;
  flex-direction: column;

  > span {
    text-align: left;
  }
`

export const LoginHeaderLabel = styled.h3`
  text-align: center;
  font-weight: bolder;
`

export const ForgotPasswordWrapper = styled.div`
  font-weight: bolder;
  color: #808080;
  &:hover {
    cursor: pointer;
  }
  margin-bottom: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
`
